let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6JCA7")).then(() => parcelRequire('4C2Ko'));